import { GraphQLErrorEnvelope } from "./graphql-error-envelope";

export function extractGraphQLErrorCode(error: unknown): string | null {
  if (!error || typeof error !== "object") {
    return null;
  }

  const code = (error as GraphQLErrorEnvelope).response?.errors?.[0]?.extensions?.code;

  return typeof code === "string" ? code : null;
}
